// sessionStorage key linking the redirect-out (here) and redirect-back
// (AciOAuthLanding) sides of the bridge OAuth round-trip.
export const ACI_RETURN_TO_KEY = 'aci_return_to'

/**
 * Redirect the browser to a backend-provided OAuth start URL (bridge flow).
 *
 * The bridge's start URL carries linked_account_owner_id == the org_app uuid. The SPA
 * navigates to it so the user lands on the provider consent screen; after consent the
 * bridge stores the linked account and redirects back to the console.
 */
export const redirectToOAuth = (url: string): void => {
  // Capture where the connect was initiated so the OAuth landing page
  // (/integrations) can return the user here after it finalizes the connection.
  // Do NOT overwrite an already-set return-to: a caller that navigated here from
  // elsewhere (e.g. the KB-create "Connect now" banner) stashed its own origin first,
  // and this page's own redirect must preserve it rather than clobber it with the
  // integrations page.
  try {
    if (!sessionStorage.getItem(ACI_RETURN_TO_KEY)) {
      sessionStorage.setItem(ACI_RETURN_TO_KEY, window.location.pathname + window.location.search)
    }
  } catch {
    // ignore storage write failures (private mode, etc.)
  }
  window.location.assign(url)
}
